import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ApolloProvider, gql, useQuery } from '@apollo/client';
import apolloClient from 'common/ApolloClient';
import Select from 'react-select';
import styles from '../index.module.scss';

const UnitNotebookSelectsWrapper = props => (
  <ApolloProvider client={apolloClient}>
    <UnitNotebookSelects {...props} />
  </ApolloProvider>
);

// graphql query for unit notebooks
const GET_INITIAL_DROPDOWN_OPTIONS = gql`
  query getInitialDropdownOptions($programId: ID!, $lessonId: ID, $unitId: ID, $isLesson: Boolean!) {
    lesson(id: $lessonId) @include(if: $isLesson) {
      unit(programId: $programId) {
        id,
        unitNotebooks {
          title,
          id,
        }
      }
    },
    unit(id: $unitId) @skip(if: $isLesson) {
      unitNotebooks {
        title,
        id,
      }
    }
  }
`;

const UnitNotebookSelects = (props) => {
  // Initialize initial notebook
  const [notebookOption, setNotebookOption] = useState({ id: 0, title: '' });

  const queryData = {
    fetchPolicy: 'network-only',
    variables: {
      isLesson: !!props.lessonId,
      lessonId: props.lessonId,
      programId: props.programId,
      unitId: props.unitId
    }
  };
  const { loading, data, error } = useQuery(GET_INITIAL_DROPDOWN_OPTIONS, queryData);

  useEffect(() => {
    if (error) {
      props.setHasError(true);
      // eslint-disable-next-line no-console
      console.error(error);
      return;
    }

    if (loading) return;

    // When data is loaded, use first notebook label/value for dropdown option
    const dataPrefix = props.lessonId ? data.lesson : data;

    // If exerciseId is defined, filter through data for matching notebook.
    let initialNotebook;
    if (props.exerciseId) {
      initialNotebook = dataPrefix.unit.unitNotebooks.filter(notebook => notebook.id === props.exerciseId.toString());
    }

    // If matching notebook is found, use it as initial dropdown option.
    if (Array.isArray(initialNotebook) && initialNotebook.length) {
      setNotebookOption({
        label: initialNotebook[0].title,
        value: props.exerciseId,
      });
    }
    else if (dataPrefix.unit && dataPrefix.unit.unitNotebooks[0]) {
      setNotebookOption({
        label: dataPrefix.unit.unitNotebooks[0].title,
        value: dataPrefix.unit.unitNotebooks[0].id,
      });

      // Pass exerciseId back to QuestionPicker to render questions.
      props.setExerciseId(parseInt(dataPrefix.unit.unitNotebooks[0].id, 10));
    }
  }, [data]);

  const handleNotebookChange = (e) => {
    // Set component state to chosen dropdown option
    setNotebookOption(e.value);

    // Pass exerciseId back to QuestionPicker to render questions.
    props.setExerciseId(parseInt(e.value, 10));
  };

  const getOptions = () => {
    if (props.lessonId) {
      return (
        data.lesson.unit.unitNotebooks.map(notebook => ({
          label: notebook.title,
          value: notebook.id,
        }))
      );
    }

    return (
      data.unit.unitNotebooks.map(notebook => ({
        label: notebook.title,
        value: notebook.id,
      }))
    );
  };

  return (
    <>
      {!loading && (
        <div className={`${styles.modelSelect}`}>
          <label htmlFor="notebook-select">
            <p>Notebooks:</p>
          </label>
          <Select
            className={`${styles.select} model-select`}
            id="notebook-select"
            label="notebook-select"
            options={getOptions()}
            value={notebookOption}
            onChange={handleNotebookChange}
          />
        </div>
      )}
    </>
  );
};

UnitNotebookSelects.propTypes = {
  exerciseId: PropTypes.number,
  lessonId: PropTypes.number,
  programId: PropTypes.number.isRequired,
  setExerciseId: PropTypes.func.isRequired,
  setHasError: PropTypes.func.isRequired,
  unitId: PropTypes.number,
};

export default UnitNotebookSelectsWrapper;
